/* ============================================================
   EVENTS PAGE — Constants, Mock Data & Utility Functions
   ============================================================ */

/* ============================================================
   FONT IMPORTS
   ============================================================ */
export const FONT_IMPORT_URL =
  "https://fonts.googleapis.com/css2?family=Google+Sans:ital,opsz,wght@0,17..18,400..700;1,17..18,400..700&family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap";

/* ============================================================
   DESIGN TOKENS
   ============================================================ */
export const TOKENS = {
  bg: "#ffffff",
  heading: "#861b68",
  body: "#000000",
  border: "#eeeeee",
  inputBorder: "#d9d9d9",
  muted: "#6b6b6b",
  gradientStart: "#861b68",
  gradientEnd: "#a32480",
  btnShadow: "0 12px 30px #861b684d",
  radiusPill: "28px",
  radiusCard: "20px",
  radiusInput: "14px",
  radiusImage: "16px",
  maxWidth: "1200px",
};

/* ============================================================
   CONSTANTS
   ============================================================ */
export const COUNTRY_CODES = [
  { short: "IN", code: "+91" },
  { short: "US", code: "+1" },
  { short: "GB", code: "+44" },
  { short: "AE", code: "+971" },
  { short: "SG", code: "+65" },
  { short: "AU", code: "+61" },
  { short: "CA", code: "+1" },
  { short: "DE", code: "+49" },
  { short: "FR", code: "+33" },
  { short: "ZA", code: "+27" },
];

export const DESIGNATIONS = [
  "Founder",
  "Co-Founder",
  "Managing Director",
  "Director",
  "Chief Executive Officer (CEO)",
  "Chief Operating Officer (COO)",
  "Manager",
  "Assistant Vice President",
  "Head of Contracting",
  "Partner",
  "Proprietor",
  "Senior Manager",
  "Project Manager",
  "Operations Manager",
  "Other",
];

export const BUSINESS_AREAS = [
  "Outbound",
  "Inbound",
  "Corporate",
  "Luxury / HNI",
  "MICE",
  "Event",
  "Groups",
  "Hotel",
  "Airlines",
  "Others",
];

export const ARRIVAL_TIMES = [
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "01:00 PM",
  "01:30 PM",
  "02:00 PM",
  "02:30 PM",
  "03:00 PM",
  "03:30 PM",
  "04:00 PM",
  "04:30 PM",
  "05:00 PM",
];

export const REFERENCE_PERSONS = ["Punam Singh", "Sandip Shaw", "Abishek Garg"];

/* ============================================================
   DATE HELPERS
   ============================================================ */
export const now = new Date();

export function addHours(base, hours) {
  return new Date(base.getTime() + hours * 60 * 60 * 1000);
}

export function addDays(base, days) {
  return new Date(base.getTime() + days * 24 * 60 * 60 * 1000);
}

export function toDateStr(d) {
  return d.toISOString().slice(0, 10);
}

/* ============================================================
   MOCK EVENTS
   ============================================================ */
const upcomingFree = addDays(now, 10);
const upcomingFee = addHours(now, 30);
const upcomingCutoff = addHours(now, 6);
const upcomingBrowseOnly = addDays(now, 21);

export const EVENTS = [
  {
    id: 1,
    title: "Hospitality Leadership Summit 2025",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
    dateObj: upcomingFree,
    date: toDateStr(upcomingFree),
    startTime: "09:30",
    endTime: "17:00",
    startTimeLabel: "09:30 AM",
    endTimeLabel: "05:00 PM",
    location: "New Delhi, Delhi, India",
    attendees: "120+ Attendees",
    description:
      "Join industry leaders and professionals for insights, networking and growth opportunities.",
    about:
      "This summit brings together senior hospitality and travel leaders for a full day of curated conversations on evolving guest experience, operational excellence, and sustainable growth. Expect focused sessions, structured networking, and practical takeaways for your business.",
    attended: false,
  },
  {
    id: 2,
    title: "MICE Growth & Partnerships Forum",
    image:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1200&q=80",
    dateObj: upcomingFee,
    date: toDateStr(upcomingFee),
    startTime: "10:00",
    endTime: "16:30",
    startTimeLabel: "10:00 AM",
    endTimeLabel: "04:30 PM",
    location: "Gurugram, Haryana, India",
    attendees: "80+ Attendees",
    description:
      "A focused forum for MICE and corporate travel partners to explore new collaboration opportunities.",
    about:
      "Meet destination partners, venue teams, and corporate travel buyers in a single room. The forum is designed around structured meeting slots and short-format sessions to help you build partnerships that convert.",
    attended: false,
  },
  {
    id: 3,
    title: "Luxury Travel & HNI Experience Day",
    image:
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
    dateObj: upcomingCutoff,
    date: toDateStr(upcomingCutoff),
    startTime: "11:00",
    endTime: "18:00",
    startTimeLabel: "11:00 AM",
    endTimeLabel: "06:00 PM",
    location: "Mumbai, Maharashtra, India",
    attendees: "60+ Attendees",
    description:
      "An exclusive day of curated experiences and conversations for luxury travel specialists.",
    about:
      "Designed for professionals serving luxury and high-net-worth clientele, this session covers emerging destinations, bespoke itineraries, and service standards that define premium travel today.",
    attended: false,
  },
  {
    id: 4,
    title: "Corporate Travel Buyers Roundtable",
    image:
      "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80",
    dateObj: upcomingBrowseOnly,
    date: toDateStr(upcomingBrowseOnly),
    startTime: "09:00",
    endTime: "13:00",
    startTimeLabel: "09:00 AM",
    endTimeLabel: "01:00 PM",
    location: "Bengaluru, Karnataka, India",
    attendees: "100+ Attendees",
    description:
      "A morning roundtable connecting corporate travel buyers with trusted service partners.",
    about:
      "A compact, high-value morning session covering corporate travel policy trends, vendor consolidation, and cost optimisation strategies, followed by open networking.",
    attended: false,
  },
  {
    id: 5,
    title: "Airline & Trade Partners Meet 2024",
    image:
      "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1200&q=80",
    dateObj: addDays(now, -40),
    date: toDateStr(addDays(now, -40)),
    startTime: "10:00",
    endTime: "17:00",
    startTimeLabel: "10:00 AM",
    endTimeLabel: "05:00 PM",
    location: "New Delhi, Delhi, India",
    attendees: "150+ Attendees",
    description:
      "An industry meet connecting airline partners with travel trade professionals.",
    about:
      "Attendees engaged directly with airline commercial teams, explored new fare and route opportunities, and took part in structured trade-facing sessions.",
    attended: true,
  },
  {
    id: 6,
    title: "Sustainable Tourism Conclave",
    image:
      "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1200&q=80",
    dateObj: addDays(now, -18),
    date: toDateStr(addDays(now, -18)),
    startTime: "09:30",
    endTime: "16:00",
    startTimeLabel: "09:30 AM",
    endTimeLabel: "04:00 PM",
    location: "Jaipur, Rajasthan, India",
    attendees: "90+ Attendees",
    description:
      "A conclave focused on responsible and sustainable practices across the travel industry.",
    about:
      "Sessions covered sustainable destination management, responsible tourism certifications, and case studies from operators leading the shift toward greener travel.",
    attended: false,
  },
  {
    id: 7,
    title: "Hotel Contracting Masterclass",
    image:
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=1200&q=80",
    dateObj: addDays(now, -65),
    date: toDateStr(addDays(now, -65)),
    startTime: "10:00",
    endTime: "15:00",
    startTimeLabel: "10:00 AM",
    endTimeLabel: "03:00 PM",
    location: "Goa, India",
    attendees: "70+ Attendees",
    description:
      "A masterclass on modern hotel contracting practices and negotiation strategy.",
    about:
      "A hands-on session covering rate negotiation, allotment planning, and long-term contracting strategy with hotel partners across leisure and business markets.",
    attended: true,
  },
];

/* ============================================================
   MOCK BOOKINGS (React state seed)
   ============================================================ */
export const INITIAL_BOOKINGS = {
  1: {
    eventId: 1,
    fullName: "Rahul Sharma",
    email: "rahul@example.com",
    websiteName: "ABC Travels",
    countryCode: "+91",
    countryShortCode: "IN",
    mobileNumber: "9876543210",
    designation: "Managing Director",
    businessArea: "Corporate",
    arrivalTime: "11:30 AM",
    referencePerson: "Punam Singh",
    status: "pending",
    requestedAt: toDateStr(addDays(now, -1)),
  },
  2: {
    eventId: 2,
    fullName: "Neha Kapoor",
    email: "neha@globaltourism.example",
    websiteName: "Global Tourism Solutions",
    countryCode: "+91",
    countryShortCode: "IN",
    mobileNumber: "9123456780",
    designation: "Director",
    businessArea: "MICE",
    arrivalTime: "10:30 AM",
    referencePerson: "Sandip Shaw",
    status: "accepted",
    requestedAt: toDateStr(addDays(now, -3)),
  },
  3: {
    eventId: 3,
    fullName: "Aarav Mehta",
    email: "aarav@luxuryescapes.example",
    websiteName: "Luxury Escapes India",
    countryCode: "+91",
    countryShortCode: "IN",
    mobileNumber: "9988776655",
    designation: "Founder",
    businessArea: "Luxury / HNI",
    arrivalTime: "11:00 AM",
    referencePerson: "Abishek Garg",
    status: "pending",
    requestedAt: toDateStr(addDays(now, -2)),
  },
};

/* ============================================================
   UTILITY FUNCTIONS
   ============================================================ */
export function getEventStartDateTime(evt) {
  const [h, m] = evt.startTime.split(":").map(Number);
  const d = new Date(evt.dateObj);
  d.setHours(h, m, 0, 0);
  return d;
}

export function isPastEvent(evt) {
  return getEventStartDateTime(evt).getTime() < now.getTime();
}

export function isUpcomingEvent(evt) {
  return getEventStartDateTime(evt).getTime() >= now.getTime();
}

export function formatDateLong(dateObj) {
  return dateObj.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export function getCancellationState(eventDateTime, currentDateTime) {
  const diffMs = eventDateTime.getTime() - currentDateTime.getTime();
  const hoursUntilEvent = diffMs / (1000 * 60 * 60);

  let state = "unavailable";
  if (hoursUntilEvent > 48) {
    state = "free";
  } else if (hoursUntilEvent > 24 && hoursUntilEvent <= 48) {
    state = "fee";
  } else {
    state = "unavailable";
  }

  return { state, hoursUntilEvent };
}

export function formatHoursRemaining(hours) {
  if (hours <= 0) return "0 hours 0 minutes";
  const totalMinutes = Math.floor(hours * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${h} hours ${m} minutes`;
}

/* ============================================================
   VALIDATION FUNCTIONS
   ============================================================ */
export function validateFullName(value) {
  const trimmed = value.trim();
  if (!trimmed) return "Full Name is required.";
  if (!/^[A-Za-z\s]+$/.test(trimmed)) {
    return "Full Name can contain letters and spaces only.";
  }
  return "";
}

export function validateEmail(value) {
  const trimmed = value.trim();
  if (!trimmed) return "Email Address is required.";
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(trimmed)) {
    return "Please enter a valid email address.";
  }
  return "";
}

export function validateWebsiteName(value) {
  if (!value.trim()) return "Website Name is required.";
  return "";
}

export function validateDropdown(value, message) {
  if (!value) return message;
  return "";
}

export function validateMobile(value) {
  if (!value) return "Mobile Number is required.";
  if (!/^\d+$/.test(value)) return "Mobile number can contain digits only.";
  if (value.length !== 10) return "Mobile number must contain exactly 10 digits.";
  return "";
}
